export const categoryData: Record<string, {
  name: string;
  description: string;
  icon: string;
  heroImage: string;
  articles: Array<{
    id: string;
    title: string;
    subtitle: string;
    image: string;
    hotScore: number;
  }>;
  gridItems: Array<{
    id: string;
    title: string;
    subtitle: string;
    image: string;
    bgTint: string;
  }>;
}> = {
  'star-gossip': {
    name: '明星爆料',
    description: '全网最新明星八卦、恋情曝光、塌房实录，第一时间为你送上最劲爆的明星黑料',
    icon: 'ri-star-line',
    heroImage: 'https://readdy.ai/api/search-image?query=Red%20carpet%20event%20with%20celebrities%20posing%20for%20photos%2C%20flash%20photography%2C%20glamorous%20atmosphere%2C%20luxury%20fashion%2C%20warm%20golden%20spotlights%2C%20entertainment%20industry%20scene%2C%20cinematic%20photography&width=800&height=1000&seq=cat-star-hero&orientation=portrait',
    articles: [
      {
        id: 'star-1',
        title: '某影帝深夜约会神秘女',
        subtitle: '两人牵手散步被拍',
        image: 'https://readdy.ai/api/search-image?query=Couple%20walking%20hand%20in%20hand%20on%20a%20romantic%20night%20street%2C%20warm%20street%20lamps%2C%20blurry%20background%2C%20paparazzi%20style%20photography%2C%20cinematic%20night%20scene%20with%20warm%20golden%20tones&width=600&height=600&seq=star-01&orientation=squarish',
        hotScore: 92134
      },
      {
        id: 'star-2',
        title: '女星整容失败后首露面',
        subtitle: '面部僵硬引网友热议',
        image: 'https://readdy.ai/api/search-image?query=Actress%20wearing%20sunglasses%20and%20mask%20at%20airport%2C%20hiding%20face%2C%20surrounded%20by%20reporters%2C%20dramatic%20flash%20photography%2C%20tense%20atmosphere%2C%20warm%20terminal%20lighting&width=600&height=600&seq=star-02&orientation=squarish',
        hotScore: 87562
      },
      {
        id: 'star-3',
        title: '某导演片场暴怒视频流出',
        subtitle: '对工作人员破口大骂',
        image: 'https://readdy.ai/api/search-image?query=Film%20set%20with%20angry%20director%20shouting%2C%20crew%20members%20looking%20scared%2C%20dramatic%20lighting%2C%20tense%20atmosphere%2C%20behind%20the%20scenes%20movie%20production%2C%20warm%20studio%20lights&width=600&height=600&seq=star-03&orientation=squarish',
        hotScore: 81209
      },
      {
        id: 'star-4',
        title: '当红小花片酬曝光',
        subtitle: '单集片酬高达八位数',
        image: 'https://readdy.ai/api/search-image?query=Luxury%20apartment%20interior%20with%20expensive%20furniture%20and%20art%2C%20stacks%20of%20money%20on%20a%20glass%20table%2C%20wealth%20display%2C%20warm%20golden%20lighting%2C%20luxurious%20atmosphere&width=600&height=600&seq=star-04&orientation=squarish',
        hotScore: 78934
      }
    ],
    gridItems: [
      {
        id: 'star-grid-1',
        title: '某男星婚内出轨实锤',
        subtitle: '酒店监控视频流出',
        image: 'https://readdy.ai/api/search-image?query=Luxury%20hotel%20corridor%20at%20night%20with%20dim%20lighting%2C%20two%20people%20entering%20a%20room%2C%20surveillance%20camera%20style%2C%20warm%20pink%20ambient%20light%2C%20mysterious%20atmosphere&width=600&height=800&seq=star-grid-01&orientation=portrait',
        bgTint: 'pink'
      },
      {
        id: 'star-grid-2',
        title: '某女团C位争夺战',
        subtitle: '后台争吵录音曝光',
        image: 'https://readdy.ai/api/search-image?query=Backstage%20of%20a%20concert%20with%20two%20performers%20arguing%2C%20dressing%20room%20mirrors%2C%20dramatic%20mint%20green%20lighting%2C%20tense%20atmosphere%2C%20entertainment%20industry&width=600&height=800&seq=star-grid-02&orientation=portrait',
        bgTint: 'mint'
      },
      {
        id: 'star-grid-3',
        title: '老艺术家晚节不保',
        subtitle: '税务问题被立案调查',
        image: 'https://readdy.ai/api/search-image?query=Government%20building%20with%20official%20seal%20and%20documents%2C%20investigation%20theme%2C%20serious%20atmosphere%2C%20gray%20toned%20lighting%2C%20legal%20concept%20photography&width=600&height=800&seq=star-grid-03&orientation=portrait',
        bgTint: 'gray'
      },
      {
        id: 'star-grid-4',
        title: '某选秀冠军涉嫌抄袭',
        subtitle: '原创音乐人集体维权',
        image: 'https://readdy.ai/api/search-image?query=Music%20studio%20with%20instruments%20and%20sheet%20music%2C%20creative%20dispute%20concept%2C%20warm%20golden%20amber%20lighting%2C%20artistic%20atmosphere%2C%20copyright%20infringement%20theme&width=600&height=800&seq=star-grid-04&orientation=portrait',
        bgTint: 'amber'
      }
    ]
  },
  'influencer-drama': {
    name: '网红黑料',
    description: '网红圈最新翻车现场、人设崩塌、虚假宣传全纪录，让你看清屏幕背后的真相',
    icon: 'ri-user-smile-line',
    heroImage: 'https://readdy.ai/api/search-image?query=Influencer%20filming%20with%20ring%20light%20and%20camera%20setup%2C%20social%20media%20content%20creation%2C%20behind%20the%20scenes%2C%20modern%20studio%20with%20warm%20lighting%2C%20youth%20culture%20photography&width=800&height=1000&seq=cat-influ-hero&orientation=portrait',
    articles: [
      {
        id: 'inf-1',
        title: '美妆博主带货翻车',
        subtitle: '粉丝使用产品后烂脸',
        image: 'https://readdy.ai/api/search-image?query=Makeup%20products%20scattered%20on%20a%20vanity%20table%2C%20broken%20compact%20powder%2C%20dramatic%20lighting%2C%20beauty%20disaster%20concept%2C%20warm%20rose%20and%20pink%20tones&width=600&height=600&seq=inf-01&orientation=squarish',
        hotScore: 89123
      },
      {
        id: 'inf-2',
        title: '吃播博主假吃被实锤',
        subtitle: '剪辑漏洞被网友发现',
        image: 'https://readdy.ai/api/search-image?query=Food%20table%20with%20various%20dishes%2C%20hidden%20trash%20bin%20concept%2C%20mukbang%20setup%2C%20warm%20food%20photography%20lighting%2C%20deceptive%20presentation&width=600&height=600&seq=inf-02&orientation=squarish',
        hotScore: 84567
      },
      {
        id: 'inf-3',
        title: '健身博主用药实锤',
        subtitle: '药物包裹被粉丝曝光',
        image: 'https://readdy.ai/api/search-image?query=Gym%20interior%20with%20weights%20and%20equipment%2C%20mysterious%20package%20on%20a%20bench%2C%20dramatic%20lighting%2C%20fitness%20doping%20scandal%20concept%2C%20warm%20industrial%20tones&width=600&height=600&seq=inf-03&orientation=squarish',
        hotScore: 81234
      },
      {
        id: 'inf-4',
        title: '情感博主私下PUA',
        subtitle: '多名学员联合举报',
        image: 'https://readdy.ai/api/search-image?query=Dark%20room%20with%20a%20single%20person%20at%20a%20desk%2C%20manipulation%20concept%2C%20psychological%20thriller%20atmosphere%2C%20dramatic%20shadow%20lighting%2C%20warm%20but%20ominous%20tones&width=600&height=600&seq=inf-04&orientation=squarish',
        hotScore: 78901
      }
    ],
    gridItems: [
      {
        id: 'inf-grid-1',
        title: '穿搭博主全身假货',
        subtitle: '奢侈品鉴定结果曝光',
        image: 'https://readdy.ai/api/search-image?query=Fashion%20clothing%20with%20luxury%20brand%20tags%2C%20counterfeit%20detection%20concept%2C%20magnifying%20glass%20over%20logo%2C%20warm%20pink%20lighting%2C%20fashion%20investigation&width=600&height=800&seq=inf-grid-01&orientation=portrait',
        bgTint: 'pink'
      },
      {
        id: 'inf-grid-2',
        title: '游戏主播代打实锤',
        subtitle: '直播时账号切换暴露',
        image: 'https://readdy.ai/api/search-image?query=Gaming%20setup%20with%20multiple%20monitors%2C%20RGB%20lighting%2C%20two%20different%20accounts%20on%20screens%2C%20cheating%20concept%2C%20mint%20green%20cyber%20atmosphere&width=600&height=800&seq=inf-grid-02&orientation=portrait',
        bgTint: 'mint'
      },
      {
        id: 'inf-grid-3',
        title: '知识博主学历造假',
        subtitle: '名校光环被母校否认',
        image: 'https://readdy.ai/api/search-image?query=Diploma%20certificate%20under%20investigation%20with%20red%20stamp%2C%20academic%20fraud%20concept%2C%20serious%20gray%20atmosphere%2C%20official%20document%20style%20photography&width=600&height=800&seq=inf-grid-03&orientation=portrait',
        bgTint: 'gray'
      },
      {
        id: 'inf-grid-4',
        title: '旅行博主摆拍造假',
        subtitle: '同款背景被多人拆穿',
        image: 'https://readdy.ai/api/search-image?query=Travel%20photography%20setup%20with%20camera%20and%20tripod%2C%20fake%20background%20revealed%2C%20studio%20lighting%20imitating%20sunset%2C%20warm%20amber%20deceptive%20travel%20concept&width=600&height=800&seq=inf-grid-04&orientation=portrait',
        bgTint: 'amber'
      }
    ]
  },
  'chat-leaks': {
    name: '聊天记录',
    description: '明星网红私密聊天记录大曝光，微信对话、暧昧短信，最真实的瓜都在这里',
    icon: 'ri-message-2-line',
    heroImage: 'https://readdy.ai/api/search-image?query=Smartphone%20with%20chat%20messages%20on%20screen%2C%20dramatic%20lighting%2C%20privacy%20leak%20concept%2C%20dark%20background%20with%20warm%20glow%20from%20screen%2C%20digital%20communication&width=800&height=1000&seq=cat-chat-hero&orientation=portrait',
    articles: [
      {
        id: 'chat-1',
        title: '某男星暧昧聊天记录',
        subtitle: '与多名女粉丝私信曝光',
        image: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20flirty%20text%20messages%2C%20intimate%20atmosphere%2C%20warm%20screen%20glow%20in%20darkness%2C%20privacy%20invasion%20concept&width=600&height=600&seq=chat-01&orientation=squarish',
        hotScore: 93145
      },
      {
        id: 'chat-2',
        title: '某女星群聊吐槽同行',
        subtitle: '言辞犀利令人咋舌',
        image: 'https://readdy.ai/api/search-image?query=Group%20chat%20interface%20on%20phone%20with%20angry%20messages%2C%20dramatic%20red%20lighting%2C%20gossip%20concept%2C%20social%20media%20drama&width=600&height=600&seq=chat-02&orientation=squarish',
        hotScore: 88765
      },
      {
        id: 'chat-3',
        title: '经纪人聊天记录泄露',
        subtitle: '艺人行程安排全曝光',
        image: 'https://readdy.ai/api/search-image?query=Business%20chat%20messages%20on%20laptop%20screen%2C%20schedule%20and%20appointments%20visible%2C%20corporate%20espionage%20concept%2C%20warm%20office%20lighting&width=600&height=600&seq=chat-03&orientation=squarish',
        hotScore: 84321
      },
      {
        id: 'chat-4',
        title: '某导演潜规则聊天',
        subtitle: '试镜邀约内容不堪入目',
        image: 'https://readdy.ai/api/search-image?query=Dark%20room%20with%20phone%20screen%20illuminating%20a%20worried%20face%2C%20casting%20couch%20concept%2C%20dramatic%20chiaroscuro%20lighting%2C%20warm%20ominous%20tones&width=600&height=600&seq=chat-04&orientation=squarish',
        hotScore: 81209
      }
    ],
    gridItems: [
      {
        id: 'chat-grid-1',
        title: '某歌手前女友爆料',
        subtitle: '分手后聊天记录全公开',
        image: 'https://readdy.ai/api/search-image?query=Heartbroken%20person%20looking%20at%20phone%20with%20tears%2C%20breakup%20concept%2C%20warm%20pink%20emotional%20lighting%2C%20relationship%20drama%20photography&width=600&height=800&seq=chat-grid-01&orientation=portrait',
        bgTint: 'pink'
      },
      {
        id: 'chat-grid-2',
        title: '某网红私密群聊流出',
        subtitle: '粉丝群内尺度言论曝光',
        image: 'https://readdy.ai/api/search-image?query=Multiple%20phone%20screens%20showing%20private%20group%20chat%2C%20information%20leak%20concept%2C%20mint%20green%20digital%20atmosphere%2C%20social%20media%20scandal&width=600&height=800&seq=chat-grid-02&orientation=portrait',
        bgTint: 'mint'
      },
      {
        id: 'chat-grid-3',
        title: '某演员工作室内部群',
        subtitle: '公关策略聊天记录泄露',
        image: 'https://readdy.ai/api/search-image?query=Office%20meeting%20room%20with%20scattered%20documents%2C%20crisis%20management%20concept%2C%20gray%20professional%20atmosphere%2C%20corporate%20secrets&width=600&height=800&seq=chat-grid-03&orientation=portrait',
        bgTint: 'gray'
      },
      {
        id: 'chat-grid-4',
        title: '某夫妻私密对话曝光',
        subtitle: '婚姻危机聊天记录流出',
        image: 'https://readdy.ai/api/search-image?query=Two%20wedding%20rings%20next%20to%20a%20phone%20showing%20argument%20texts%2C%20marriage%20crisis%20concept%2C%20warm%20amber%20melancholic%20lighting&width=600&height=800&seq=chat-grid-04&orientation=portrait',
        bgTint: 'amber'
      }
    ]
  },
  'daily-contest': {
    name: '每日大赛',
    description: '每日最劲爆吃瓜大赛，网红反差、明星塌房、黑料视频，看看今天谁最离谱',
    icon: 'ri-fire-line',
    heroImage: 'https://readdy.ai/api/search-image?query=Dramatic%20competition%20stage%20with%20spotlights%20and%20trophy%2C%20gossip%20show%20concept%2C%20entertainment%20awards%20atmosphere%2C%20warm%20golden%20spotlights%2C%20dramatic%20stage%20lighting&width=800&height=1000&seq=cat-contest-hero&orientation=portrait',
    articles: [
      {
        id: 'contest-1',
        title: '今日最劲爆：某顶流被拍到夜店亲密',
        subtitle: '与三女同行至凌晨四点',
        image: 'https://readdy.ai/api/search-image?query=Nightclub%20exterior%20at%20night%20with%20neon%20lights%2C%20people%20partying%2C%20dramatic%20nightlife%20atmosphere%2C%20warm%20red%20and%20golden%20neon%20glow&width=600&height=600&seq=contest-01&orientation=squarish',
        hotScore: 98765
      },
      {
        id: 'contest-2',
        title: '某女星红毯摔倒走光',
        subtitle: '网友质疑是故意炒作',
        image: 'https://readdy.ai/api/search-image?query=Red%20carpet%20event%20with%20dramatic%20fall%20moment%2C%20cameras%20flashing%2C%20embarrassing%20wardrobe%20malfunction%2C%20warm%20event%20lighting&width=600&height=600&seq=contest-02&orientation=squarish',
        hotScore: 95432
      },
      {
        id: 'contest-3',
        title: '某综艺选手当场退赛',
        subtitle: '怒斥节目组黑幕操作',
        image: 'https://readdy.ai/api/search-image?query=Reality%20show%20stage%20with%20contestant%20walking%20off%20angrily%2C%20judges%20shocked%2C%20dramatic%20studio%20lighting%2C%20television%20production&width=600&height=600&seq=contest-03&orientation=squarish',
        hotScore: 92876
      },
      {
        id: 'contest-4',
        title: '某富豪包养多名网红',
        subtitle: '转账记录令人咋舌',
        image: 'https://readdy.ai/api/search-image?query=Luxury%20yacht%20party%20with%20beautiful%20people%2C%20champagne%20and%20money%2C%20wealthy%20lifestyle%2C%20warm%20golden%20sunset%20lighting%2C%20luxury%20atmosphere&width=600&height=600&seq=contest-04&orientation=squarish',
        hotScore: 90543
      }
    ],
    gridItems: [
      {
        id: 'contest-grid-1',
        title: '今日冠军：某顶流塌房',
        subtitle: '前女友凌晨发长文实锤',
        image: 'https://readdy.ai/api/search-image?query=Person%20typing%20on%20phone%20in%20dark%20room%2C%20explosive%20revelation%20concept%2C%20warm%20pink%20dramatic%20lighting%2C%20social%20media%20expose&width=600&height=800&seq=contest-grid-01&orientation=portrait',
        bgTint: 'pink'
      },
      {
        id: 'contest-grid-2',
        title: '昨日回顾：综艺录制冲突',
        subtitle: '全场混乱画面曝光',
        image: 'https://readdy.ai/api/search-image?query=Chaotic%20TV%20studio%20with%20people%20running%2C%20equipment%20falling%2C%20dramatic%20mint%20green%20studio%20lighting%2C%20live%20show%20disaster&width=600&height=800&seq=contest-grid-02&orientation=portrait',
        bgTint: 'mint'
      },
      {
        id: 'contest-grid-3',
        title: '黑马：某演员学历门',
        subtitle: '博士学位被质疑造假',
        image: 'https://readdy.ai/api/search-image?query=Academic%20certificate%20with%20question%20mark%2C%20diploma%20investigation%2C%20serious%20gray%20atmosphere%2C%20education%20fraud%20scandal&width=600&height=800&seq=contest-grid-03&orientation=portrait',
        bgTint: 'gray'
      },
      {
        id: 'contest-grid-4',
        title: '番外：豪门离婚案开庭',
        subtitle: '百亿财产分割引关注',
        image: 'https://readdy.ai/api/search-image?query=Courthouse%20exterior%20with%20reporters%20gathered%2C%20high%20profile%20divorce%20case%2C%20warm%20amber%20afternoon%20lighting%2C%20legal%20drama&width=600&height=800&seq=contest-grid-04&orientation=portrait',
        bgTint: 'amber'
      }
    ]
  },
  'show-fails': {
    name: '综艺翻车',
    description: '综艺节目录制事故、选手导师冲突、节目造假黑幕，台前幕后的精彩都在这里',
    icon: 'ri-tv-line',
    heroImage: 'https://readdy.ai/api/search-image?query=TV%20studio%20with%20dramatic%20stage%20lighting%20and%20empty%20audience%20seats%2C%20behind%20the%20scenes%20reality%20show%2C%20warm%20professional%20lighting%2C%20entertainment%20production&width=800&height=1000&seq=cat-show-hero&orientation=portrait',
    articles: [
      {
        id: 'show-1',
        title: '某选秀节目投票造假',
        subtitle: '内部人员爆料暗箱操作',
        image: 'https://readdy.ai/api/search-image?query=Voting%20machines%20and%20screens%20in%20a%20dark%20room%2C%20election%20fraud%20concept%2C%20dramatic%20lighting%2C%20reality%20show%20scandal&width=600&height=600&seq=show-01&orientation=squarish',
        hotScore: 87654
      },
      {
        id: 'show-2',
        title: '某综艺嘉宾中途离场',
        subtitle: '被主持人言论激怒',
        image: 'https://readdy.ai/api/search-image?query=Talk%20show%20set%20with%20guest%20storming%20off%2C%20shocked%20host%2C%20dramatic%20studio%20lighting%2C%20television%20drama&width=600&height=600&seq=show-02&orientation=squarish',
        hotScore: 84321
      },
      {
        id: 'show-3',
        title: '某恋爱综艺剧本曝光',
        subtitle: 'CP线全是安排好的',
        image: 'https://readdy.ai/api/search-image?query=Dating%20show%20script%20and%20notes%20on%20a%20table%2C%20behind%20the%20scenes%20reality%20TV%2C%20warm%20romantic%20lighting%2C%20fake%20romance%20concept&width=600&height=600&seq=show-03&orientation=squarish',
        hotScore: 82109
      },
      {
        id: 'show-4',
        title: '某竞技综艺安全漏洞',
        subtitle: '选手录制中受伤送医',
        image: 'https://readdy.ai/api/search-image?query=Ambulance%20outside%20TV%20studio%2C%20emergency%20situation%2C%20dramatic%20night%20lighting%2C%20accident%20on%20set%20concept&width=600&height=600&seq=show-04&orientation=squarish',
        hotScore: 79876
      }
    ],
    gridItems: [
      {
        id: 'show-grid-1',
        title: '某音乐综艺假唱实锤',
        subtitle: '对口型失误画面曝光',
        image: 'https://readdy.ai/api/search-image?query=Singer%20on%20stage%20with%20microphone%2C%20lip%20sync%20failure%20concept%2C%20warm%20pink%20stage%20lighting%2C%20music%20performance%20scandal&width=600&height=800&seq=show-grid-01&orientation=portrait',
        bgTint: 'pink'
      },
      {
        id: 'show-grid-2',
        title: '某真人秀剪辑造假',
        subtitle: '时间线混乱被网友扒出',
        image: 'https://readdy.ai/api/search-image?query=Video%20editing%20suite%20with%20timeline%20on%20screen%2C%20manipulation%20concept%2C%20mint%20green%20digital%20atmosphere%2C%20post%20production&width=600&height=800&seq=show-grid-02&orientation=portrait',
        bgTint: 'mint'
      },
      {
        id: 'show-grid-3',
        title: '某访谈节目主持失态',
        subtitle: '对嘉宾进行人身攻击',
        image: 'https://readdy.ai/api/search-image?query=Interview%20set%20with%20angry%20host%20pointing%20finger%2C%20uncomfortable%20guest%2C%20gray%20tense%20atmosphere%2C%20talk%20show%20conflict&width=600&height=800&seq=show-grid-03&orientation=portrait',
        bgTint: 'gray'
      },
      {
        id: 'show-grid-4',
        title: '某综艺道具失误合集',
        subtitle: '舞台坍塌场面失控',
        image: 'https://readdy.ai/api/search-image?query=Stage%20set%20collapsing%20during%20live%20show%2C%20props%20failure%2C%20dramatic%20warm%20amber%20lighting%2C%20production%20disaster&width=600&height=800&seq=show-grid-04&orientation=portrait',
        bgTint: 'amber'
      }
    ]
  },
  'rich-drama': {
    name: '豪门恩怨',
    description: '富豪家族八卦、豪门婚姻内幕、商业大佬私生活，有钱人的世界就是这么精彩',
    icon: 'ri-vip-crown-line',
    heroImage: 'https://readdy.ai/api/search-image?query=Luxury%20mansion%20exterior%20at%20golden%20hour%2C%20wealthy%20lifestyle%2C%20grand%20architecture%2C%20dramatic%20lighting%2C%20elite%20society%20concept%2C%20warm%20luxurious%20tones&width=800&height=1000&seq=cat-rich-hero&orientation=portrait',
    articles: [
      {
        id: 'rich-1',
        title: '某地产大亨婚变',
        subtitle: '原配与小三大打出手',
        image: 'https://readdy.ai/api/search-image?query=Luxury%20living%20room%20in%20chaos%20after%20fight%2C%20broken%20vase%2C%20dramatic%20lighting%2C%20domestic%20conflict%2C%20wealthy%20household%20drama&width=600&height=600&seq=rich-01&orientation=squarish',
        hotScore: 91234
      },
      {
        id: 'rich-2',
        title: '某餐饮巨头偷税被查',
        subtitle: '公司账户被冻结',
        image: 'https://readdy.ai/api/search-image?query=Corporate%20office%20with%20government%20seal%20on%20documents%2C%20tax%20investigation%2C%20serious%20atmosphere%2C%20business%20scandal&width=600&height=600&seq=rich-02&orientation=squarish',
        hotScore: 88765
      },
      {
        id: 'rich-3',
        title: '某富二代夜店斗殴',
        subtitle: '挥金如土炫富引众怒',
        image: 'https://readdy.ai/api/search-image?query=VIP%20nightclub%20section%20with%20champagne%20bottles%2C%20money%20scattered%2C%20dramatic%20neon%20lighting%2C%20rich%20kid%20lifestyle%20scandal&width=600&height=600&seq=rich-03&orientation=squarish',
        hotScore: 85432
      },
      {
        id: 'rich-4',
        title: '某家族企业继承权之争',
        subtitle: '三代人反目对簿公堂',
        image: 'https://readdy.ai/api/search-image?query=Family%20portrait%20with%20cracks%2C%20inheritance%20dispute%20concept%2C%20dramatic%20lighting%2C%20wealthy%20family%20conflict%2C%20warm%20but%20tense%20atmosphere&width=600&height=600&seq=rich-04&orientation=squarish',
        hotScore: 83210
      }
    ],
    gridItems: [
      {
        id: 'rich-grid-1',
        title: '某女星嫁入豪门后',
        subtitle: '婆婆刁难生活苦不堪言',
        image: 'https://readdy.ai/api/search-image?query=Luxury%20dining%20room%20with%20tense%20family%20dinner%2C%20mother%20in%20law%20conflict%2C%20warm%20pink%20uncomfortable%20atmosphere%2C%20wealthy%20family%20drama&width=600&height=800&seq=rich-grid-01&orientation=portrait',
        bgTint: 'pink'
      },
      {
        id: 'rich-grid-2',
        title: '某富商包机追网红',
        subtitle: '月花百万只为博一笑',
        image: 'https://readdy.ai/api/search-image?query=Private%20jet%20interior%20with%20luxury%20decor%2C%20champagne%20and%20gifts%2C%20mint%20green%20luxury%20atmosphere%2C%20wealthy%20lifestyle&width=600&height=800&seq=rich-grid-02&orientation=portrait',
        bgTint: 'mint'
      },
      {
        id: 'rich-grid-3',
        title: '某企业家破产内幕',
        subtitle: '一夜之间从百亿到负债',
        image: 'https://readdy.ai/api/search-image?query=Empty%20office%20building%20with%20foreclosure%20notice%2C%20bankruptcy%20concept%2C%20gray%20depressing%20atmosphere%2C%20business%20failure&width=600&height=800&seq=rich-grid-03&orientation=portrait',
        bgTint: 'gray'
      },
      {
        id: 'rich-grid-4',
        title: '某豪门千金私奔',
        subtitle: '为爱放弃百亿家产',
        image: 'https://readdy.ai/api/search-image?query=Woman%20running%20away%20from%20luxury%20mansion%20at%20sunset%2C%20romantic%20escape%20concept%2C%20warm%20amber%20dramatic%20lighting%2C%20forbidden%20love&width=600&height=800&seq=rich-grid-04&orientation=portrait',
        bgTint: 'amber'
      }
    ]
  }
};

export const allCategorySlugs = Object.keys(categoryData);